<template>
<div :class=" search_status ? 'index page_fenlei page_map page_iteminfo page_art page_limit': 'index page_fenlei page_art page_map page_iteminfo'">
    <!-- 顶部搜索 -->
    <div class="top_wrap">
        <div class="index_top top_nobg">
            <div class="PageSearch page-search">
                <van-row type="flex" justify="space-start">
                    <van-col v-if="searchlefticon" class="left_col">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'" @click="toSearch">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="placeholder" disabled>
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                </van-row>
            </div>
        </div>
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <div>
                <!-- 选择项目 -->
                <div class="search_fenlei">
                    <div class="search_title">匠人分类</div>
                    <ul class="search_list clearfix">
                        <li :class="cate.isSelect?'search_item f-l active':'search_item f-l'" v-for="cate in cateList" :key="cate.id" @click="cateClick(cate)">{{cate.name}}</li>
                    </ul>
                </div>
                <!-- 选择分类 -->
                <div class="search_fenlei">
                    <div class="search_title">地区分类</div>
                    <ul class="search_list clearfix">
                        <li :class="area.isSelect?'search_item f-l active':'search_item f-l'" v-for="area in areaList" :key="area.id" @click="areaClick(area)">{{area.name}}</li>
                    </ul>
                </div>
                <div class="search_fenlei">
                    <div class="search_title">技艺分类</div>
                    <ul class="search_list clearfix">
                        <li :class="skill.isSelect?'search_item f-l active':'search_item f-l'" v-for="skill in skillList" :key="skill.id" @click="skillClick(skill)">{{skill.name}}</li>
                    </ul>
                </div>
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 内容区 -->
    <div class="con_jiangren">
        <!-- 匠人 轮播区域-->
        <van-tabs v-model="type" swipe-threshold="6" @click="changeTab">
            <van-tab title="平台匠人" :name="1"></van-tab>
            <van-tab title="匠人库" :name="0"></van-tab>
        </van-tabs>
        <div v-if="type==1">
            <div :class="recommendList.length > 0 ? 'arts' : 'arts arts_un'" v-if="recommendList">
                <van-swipe :loop="false">
                    <van-swipe-item v-for="(item,index) in recommendList" :key="index">
                        <ul class="list">
                            <li class="item" v-for="tradesman in item" :key="tradesman.id" @click="toDetail(tradesman)">
                                <!-- <div class="thumb">
                                    <img :src="tradesman.thumb" alt="" class="">	
                                </div> -->
                                <van-image class="thumb" fit="cover" :src="tradesman.thumb ? ($publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb ) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                                <div class="name slh_s">{{ tradesman.nickname }}</div>
                            </li>
                        </ul>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <!-- 匠人 列表 -->
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
                    <div class="jiangren">
                        <div class="con" v-for="tradesman in tradesmanList" :key="tradesman.id">
                            <div class="con_info clearfix" @click="toDetail(tradesman)">
                                <!-- <div class="thumb f-l">
                                    <img :src="tradesman.thumb ? tradesman.thumb : $publicData.defaultTouxiang" alt="" class="">
                                </div> -->
                                <van-image class="thumb f-l" fit="cover" :src="tradesman.thumb ? ($publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb ) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                                <div class="f-l con_info_r">
                                    <div :class="tradesman.register_status ? 'name slh_s zhuced' : 'name slh_s unzhuce' ">{{ tradesman.nickname }}</div>
                                    <div class="tag slh_s" v-if="tradesman.data && tradesman.data.auth_company">{{ tradesman.data.auth_company}}</div>
                                    <!-- <div class="tag">国家级非遗</div> -->
                                </div>
                            </div>
                            <div :class="tradesman.is_attention==1 ? 'guanzhu': 'guanzhu guanzhu_no'" @click="attentionTadesmanClick(tradesman)">{{ tradesman.is_attention==1?'已关注':'关注' }}</div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <div v-else>
            <div class="arts arts_un" />
            <!-- 匠人 列表 -->
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getOtherData" :immediate-check="false">
                    <div class="jiangren">
                        <div class="con" v-for="tradesman in otradesmanList" :key="tradesman.id">
                            <div class="con_info clearfix" @click="toODetail(tradesman)">
                                <!-- <div class="thumb f-l">
                                    <img :src="tradesman.thumb ? tradesman.thumb : $publicData.defaultTouxiang" alt="" class="">
                                </div> -->
                                <van-image class="thumb f-l" fit="cover" :src="tradesman.thumb ? ($publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb ) : $publicData.defaultTouxiang" :show-error="false" :show-loading="false" />
                                <div class="f-l con_info_r">
                                    <div :class="tradesman.register_status ? 'name slh_s zhuced' : 'name slh_s unzhuce' ">{{ tradesman.nickname }}</div>
                                    <div class="tag slh_s" v-if="tradesman.data && tradesman.data.auth_company">{{ tradesman.data.auth_company }}</div>
                                    <!-- <div class="tag">国家级非遗</div> -->
                                </div>
                            </div>
                            <div :class="tradesman.is_attention==1 ? 'guanzhu': 'guanzhu guanzhu_no'" @click="attentionTadesmanClick(tradesman)">{{ tradesman.is_attention==1?'已关注':'关注' }}</div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan.png', // 搜索栏右侧图标
            search_value: '', // 搜索值
            placeholder: '请输入要搜索的匠人',
            righticon: process.env.BASE_URL + '/statics/images/search_gery_icon.png', // 搜索框搜索图标
            search_status: false,
            token: null,
            skillList: [],
            cateList: [],
            areaList: [],
            tradesmanList: [],
            otradesmanList: [],
            recommendList: [],
            finished: false,
            page: 1,
            size: 10,
            opage: 1,
            osize: 10,
            loading: false,
            refreshing: false,
            type:1,
            goNext: false,
            shareConfig: null // 分享的相关配置
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var that = this
            var params = {
                'data': {
                    'naviTitle': '匠人',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                this.onRefresh();
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '非遗匠人',
                        detail: '在人生的旅途中，他们坚守着“刻苦、精细、低调”的匠心...\n他们，以不辜负的心念坚守最澄澈的初心\n他们凭着一颗耐得住寂寞的匠心，期待时间与技艺彼此成全\n一大波传统手艺，正向你涌来！',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'jiangren.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
        }
        this.getTypeData()
        this.getSkillData()
        this.getAreaData()
        // console.log(this.$refs.marker)
    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.getShareData()
            this.onRefresh();
		}
	},
    methods: {
        toSearch() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/search/search?active=1'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/search/search',
                    query: {
						active: 1
                    }
                })
            }
        },
        search() {
            this.onRefresh()
        },
        clicksearchright() {
            this.search_status = !this.search_status
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            if (this.type == 0) {
                this.opage = 1
                this.getOtherData()
            } else {
                this.page = 1
                this.getData();
            }
        },
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                page: this.page,
                register_status: 1,
                size: this.size
            }
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.keyword = this.search_value
            }
            var cates = []
            var cateList = this.cateList
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                if (old.isSelect == true) {
                    cates.push(old.id)
                }
            }
            if (cates.length > 0) {
                params.cates = JSON.stringify(cates);
            }

            var areas = []
            var areaList = this.areaList
            for (let i = 0; i < areaList.length; i++) {
                var old = areaList[i];
                if (old.isSelect == true) {
                    areas.push(old.id)
                }
            }
            if (areas.length > 0) {
                // params.area = cates
                params.area = JSON.stringify(areas);
            }

            var skills = []
            var skillList = this.skillList
            for (let i = 0; i < skillList.length; i++) {
                var old = skillList[i];
                if (old.isSelect == true) {
                    skills.push(old.id)
                }
            }
            if (skills.length > 0) {
                params.skill = JSON.stringify(skills);
            }
            console.log('params', params)
            this.$api.tradesman.list(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list;
                    if (this.page == 1) {
                        this.tradesmanList = list
                        // 推荐匠人 按四个一组实现轮播效果
                        var arr = res.result.pos
                        var newArr = []
                        for (var i = 0; i < arr.length; i += 4) {
                            newArr.push(arr.slice(i, i + 4))
                        }
						this.recommendList = newArr
						console.log('this.recommendList----',this.recommendList)
                    } else {
                        var old = this.tradesmanList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.tradesmanList = old
                    }
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        getOtherData() { // 匠人库匠人
            var params = {
                token: this.token,
                page: this.opage,
                register_status: 0,
                size: this.osize
            }
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.keyword = this.search_value
            }
            var cates = []
            var cateList = this.cateList
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                if (old.isSelect == true) {
                    cates.push(old.id)
                }
            }
            if (cates.length > 0) {
                params.cates = cates
            }

            var areas = []
            var areaList = this.areaList
            for (let i = 0; i < areaList.length; i++) {
                var old = areaList[i];
                if (old.isSelect == true) {
                    areas.push(old.id)
                }
            }
            if (areas.length > 0) {
                // params.area = cates
                params.area = areas
            }

            var skills = []
            var skillList = this.skillList
            for (let i = 0; i < skillList.length; i++) {
                var old = skillList[i];
                if (old.isSelect == true) {
                    skills.push(old.id)
                }
            }
            if (skills.length > 0) {
                params.skill = skills
            }
            console.log('params', params)
            this.$api.tradesman.list(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list;
                    if (this.opage == 1) {
                        this.otradesmanList = list
                    } else {
                        var old = this.otradesmanList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.otradesmanList = old
                    }
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.opage++;
                this.refreshing = false
                this.loading = false;
            })
        },
        changeTab(name, title) {
            console.log(name,title);
            this.finished = false
            if (name == 0) {
                this.opage = 1;
                this.getOtherData()
            } else {
                this.page = 1;
                this.getData()
            }
        },
        //获取地区列表
        getAreaData() {
            var params = {}
            this.$api.address.areaList(params).then(res => {
                if (res.code == 200) {
                    var area = JSON.parse(res.result).areaList.province_list
                    // console.log(area)
                    var list = []
                    for (const key in area) {
                        // console.log(key)
                        var a = {}
                        a.id = key
                        a.name = area[key]
                        list.push(a)
                    }
                    this.areaList = list
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 获取匠人分类列表
        getTypeData() {
            var params = {
                // token: this.token,
            }
            this.$api.tradesman.cate(params).then(res => {
                if (res.code == 200) {
                    var cateList = res.result.list;
                    this.cateList = cateList
                } else {

                }

            })
        },
        // 获取技艺分类列表
        getSkillData() {
            var params = {
                // token: this.token,
            }
            this.$api.tradesman.skill(params).then(res => {
                if (res.code == 200) {
                    var skillList = res.result.list;
                    this.skillList = skillList
                } else {

                }

            })
		},
		// 关注匠人 对App和H5做判断
		attentionTadesmanClick(tradesman){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionTadesman(tradesman);
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionTadesman(tradesman);
			}
		},
		// 关注匠人
        attentionTadesman(tradesman) {
            var type = 1
            if (tradesman.is_attention == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: tradesman.id,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    if (tradesman.is_attention == 1) {
                        tradesman.is_attention = 0
                        this.$toast('取消关注成功')
                    } else {
                        tradesman.is_attention = 1
                        this.$toast('关注成功')
                    }
                    // this.onRefresh()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toDetail(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id + '&register_status=' + tradesman.register_status
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/art/detail',
                    query: {
						tradesmanId: tradesman.id,
						register_status: tradesman.register_status
                    }
                })
            }
        },
        toODetail(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/odetail?tradesmanId=' + tradesman.id + '&register_status=' + tradesman.register_status
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/art/odetail',
                    query: {
						tradesmanId: tradesman.id,
						register_status: tradesman.register_status
                    }
                })
            }
        },
        areaClick(area) {
            var areaList = this.areaList
            var newList = []
            for (let i = 0; i < areaList.length; i++) {
                var old = areaList[i];
                if (old.id == area.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.areaList = newList
        },
        cateClick(cate) {
            var cateList = this.cateList
            var newList = []
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                if (old.id == cate.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.cateList = newList
        },
        skillClick(skill) {
            var skillList = this.skillList
            var newList = []
            for (let i = 0; i < skillList.length; i++) {
                var old = skillList[i];
                if (old.id == skill.id) {
                    old.isSelect = !old.isSelect
                }
                newList.push(old)
            }
            this.skillList = newList
        },
        // 重置
        reset() {
            var cateList = this.cateList
            var newList = []
            for (let i = 0; i < cateList.length; i++) {
                var old = cateList[i];
                old.isSelect = false
                newList.push(old)
            }
            this.cateList = newList
            var areaList = this.areaList
            var newList = []
            for (let i = 0; i < areaList.length; i++) {
                var old = areaList[i];
                old.isSelect = false
                newList.push(old)
            }
            this.areaList = newList
            var skillList = this.skillList
            var newList = []
            for (let i = 0; i < skillList.length; i++) {
                var old = skillList[i];
                old.isSelect = false
                newList.push(old)
            }
            this.skillList = newList
        },
        // 确定
        submit() {
            this.search_status = false
            this.onRefresh()
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '非遗匠人', // 分享标题
                    desc: '在人生的旅途中，他们坚守着“刻苦、精细、低调”的匠心...\n他们，以不辜负的心念坚守最澄澈的初心\n他们凭着一颗耐得住寂寞的匠心，期待时间与技艺彼此成全\n一大波传统手艺，正向你涌来！', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'jiangren.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
